"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  getRsmList: function getRsmList() {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/bizOrgInfo/queryAllRsm',
      method: 'post'
    });
  },
  getNewCustomerList: function getNewCustomerList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/app/home/sr/newCustomer/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getVisitingList: function getVisitingList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/app/home/sr/visitRetailorMonthly/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getVisitPlanList: function getVisitPlanList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/app/home/sr/planTaskWeekly/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getCustomerDistributionList: function getCustomerDistributionList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/app/home/sr/customerDistribution/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getOrderList: function getOrderList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/app/home/sr/order/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getCCIList: function getCCIList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/app/home/sr/cciKpi/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  setLog: function setLog(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/sfeTeamPerformanceLog/save',
      method: 'post',
      data: data
    });
  },
  getLog: function getLog(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/sfeTeamPerformanceLog/list',
      method: 'post',
      data: data
    });
  },
  exportReportFile: function exportReportFile(url, data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: url,
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};